export const MIXPANEL_EVENTS = {
  PROFILE: {
    INFORMATION_TAB_LOAD: "account_personal_information_tab",
    AUTHORIZED_MEMBERS_TAB_LOAD: "account_authorized_members_tab",
    TAX_CENTER_TAB_LOAD: "account_tax_center_tab",
    DOCUMENT_CENTER_TAB_LOAD: "account_document_center_tab",
    DOCUMENTS_TAB_LOAD: "account_documents_tab",
    INVESTMENT_PROFILE_TAB_LOAD: "account_investment_profile_tab",
    SETTINGS_TAB_LOAD: "account_settings_tab",
    KEY_PARTIES_TAB_LOAD: "account_key_parties_tab",
  },
  ACCREDITATION: {
    MODAL_SHOW: "accreditation_modal_show",
    MODAL_CONFIRMED: "accreditation_modal_confirmed",
  },
  BD_TERMS_MODAL: {
    MODAL_ACCEPTED: "bd_terms_modal_accepted",
    MODAL_DISMISSED: "bd_terms_modal_dismissed",
  },
  REGISTRATION: {
    VISIT: "registration-visit",
    INIT: "registration-init",
    TRY: "registration-try",
    COMPLETE: "registration-complete",
    ERROR: "registration-error",
    COUNTRY_PHONE: "registration-countryphone",
    PHONE_VERIFICATION: "registration-phoneverification",
    PHONE_VERIFICATION_RESEND: "registration-phoneverification-resendcode",
    EMAIL_PASSWORD: "registration-emailpassword",
  },
} as const;
